import React from "react";
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';

import Feature1Icon from '../icons/feature1-icon';
import Heading3 from '../titles/Heading3';
import Paragraph from '../paragraphs/Paragraph';
import VisibilitySensor from 'react-visibility-sensor';

class Feature1Item extends React.Component {
    constructor() {
        super();
        this.state = {
            animated : false,
            animationClasses : [''],
        };
        this.headerVisible = this.headerVisible.bind(this);
    }

    headerVisible(isVisible) {
        if (isVisible) {
            if (!this.state.animated) {
                var elemIndex = this.props.index,
                timeDelay =+ elemIndex * 200;
                setTimeout(function() { 
                    var classes = this.state.animationClasses;
                    classes.push('animate-box');
                    classes.push('fadeIn');
                    classes.push('animated-fast');
                    this.setState({ animated: true, animationClasses: classes});
                }.bind(this), timeDelay);
            }
        }
    };
    render() {
        return (
            <VisibilitySensor partialVisibility={ true } onChange={ this.headerVisible } >
                <div className={"feature-center " + this.props.value.class + this.state.animationClasses.join(' ')} style={ { opacity : 0 } }>
                    <Feature1Icon iconName={ this.props.value.icon }/>
                    <Heading3 title={ this.props.value.title }/>
                    <Paragraph text={ this.props.value.description } />
                </div>
            </VisibilitySensor>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
  return {
    translate: getTranslate(state.locale),
    props: ownProps
  };
};

export default connect(mapStateToProps)(Feature1Item);


// WEBPACK FOOTER //
// ./src/components/features/feature1-item.jsx